import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vertical-app vertical-flow"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "vertical-flow__form__step vertical-flow__form__step--header mb-5" }
const _hoisted_4 = { class: "vertical-flow__form__step__title vertical-flow__form__step__title--initial" }
const _hoisted_5 = { class: "vertical-flow__form__step__text" }
const _hoisted_6 = { class: "header-sub-title" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "label" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "spacer",
  innerHTML: ' '
}, null, -1)
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "flex secondary" }
const _hoisted_12 = { class: "label" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  class: "spacer",
  innerHTML: ' '
}, null, -1)
const _hoisted_14 = { class: "content" }
const _hoisted_15 = ["id"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["textContent"]
const _hoisted_18 = { class: "vertical-flow__form__step__text" }
const _hoisted_19 = ["textContent"]
const _hoisted_20 = {
  key: 0,
  class: "flex flex__space"
}
const _hoisted_21 = { class: "truncate truncate__subtitle" }
const _hoisted_22 = { class: "buttonGroup" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "backButton--image" }, null, -1)
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 1,
  class: "row no-gutters"
}
const _hoisted_27 = { class: "col-12 mt-5" }
const _hoisted_28 = { class: "offer-load-error mt-6" }
const _hoisted_29 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VerticalStepComponent = _resolveComponent("VerticalStepComponent")!

  return (_ctx.renderPage)
    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.loadError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.model.offerIdLabel), 1),
                        _hoisted_9,
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.quote_id), 1)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.model.customerInfoLabel), 1),
                        _hoisted_13,
                        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.party.name), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from(_ctx.proposalSteps.values()), (step, inx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'step' + inx
                }, [
                  _createElementVNode("div", {
                    id: '_' + step.id,
                    class: _normalizeClass([
						'vertical-flow__form__step',
						{ 'vertical-flow__form__step--inactive': !_ctx.isActiveStep(step) },
						{ 'vertical-flow__form__step--active': _ctx.isActiveStep(step) },
						{ 'vertical-flow__form__step--validated': _ctx.isValid(step) && !_ctx.isActiveStep(step) },
					])
                  }, [
                    _createElementVNode("div", {
                      class: "vertical-flow__form__step__title",
                      onClick: ($event: any) => (_ctx.gotoStep(step))
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(['vertical-flow__form__step__number', { 'no-number-subtext': !step.description }]),
                        textContent: _toDisplayString(_ctx.isValid(step) && !_ctx.isActiveStep(step) ? '' : inx + 1)
                      }, null, 10, _hoisted_17),
                      _createElementVNode("div", _hoisted_18, [
                        _withDirectives(_createElementVNode("div", {
                          class: _normalizeClass(['truncate step step__title', { 'no-subtext': !step.description }]),
                          textContent: _toDisplayString(step.title)
                        }, null, 10, _hoisted_19), [
                          [_vShow, step.title]
                        ]),
                        (step.description)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createElementVNode("span", _hoisted_21, _toDisplayString(step.description), 1),
                              _createElementVNode("span", null, _toDisplayString(step.priceDisplay), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ], 8, _hoisted_16),
                    _createVNode(_Transition, { name: "slide-vertical-no-delay-fast" }, {
                      default: _withCtx(() => [
                        (_ctx.isActiveStep(step))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass([
								'vertical-flow__form__step__accordion text-center',
								{ 'vertical-flow__form__step__accordion--maximizeWidth': step.maximizeWidth },
							])
                            }, [
                              _createVNode(_component_VerticalStepComponent, {
                                "visible-error": _ctx.visibleError,
                                step: step
                              }, null, 8, ["visible-error", "step"]),
                              _createElementVNode("div", _hoisted_22, [
                                (_ctx.renderBackButton())
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      class: _normalizeClass(['Button Button__tertiary']),
                                      onClick: ($event: any) => (_ctx.prevStep(step))
                                    }, [
                                      _createElementVNode("span", null, [
                                        _hoisted_24,
                                        _createTextVNode(_toDisplayString(step.buttonBackLabel), 1)
                                      ])
                                    ], 8, _hoisted_23))
                                  : _createCommentVNode("", true),
                                _createElementVNode("a", {
                                  class: _normalizeClass([
										'Button Button__primary',
										{ Button__primary_disabled_with_submit: !_ctx.isValid(step) },
									]),
                                  onClick: ($event: any) => (_ctx.nextStep(step))
                                }, _toDisplayString(step.buttonLabel), 11, _hoisted_25)
                              ])
                            ], 2))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ], 10, _hoisted_15)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ], 512)), [
        [_vShow, _ctx.showPage]
      ])
    : (_ctx.loadError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", {
                class: "error-box",
                innerHTML: _ctx.loadError
              }, null, 8, _hoisted_29)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
}